import a from "./ghl-ui.es1159.js";
import c from "./ghl-ui.es1145.js";
const l = (o) => {
  const { textColorDisabled: t, iconColor: e, textColor2: m, fontSizeSmall: n, fontSizeMedium: r, fontSizeLarge: i, fontSizeHuge: s } = o;
  return Object.assign(Object.assign({}, a), {
    fontSizeSmall: n,
    fontSizeMedium: r,
    fontSizeLarge: i,
    fontSizeHuge: s,
    textColor: t,
    iconColor: e,
    extraTextColor: m
  });
}, f = {
  name: "Empty",
  common: c,
  self: l
}, x = f;
export {
  x as default,
  l as self
};
